import { CutterAudio } from '../../state/entities/CutterAudio'
import { isAudioBufferChunk } from '../functions/isAudioBufferChunk'

export function renderAudioBuffer({
  audioBuffer,
  audio: { length, chunks, numberOfChannels },
}: {
  audioBuffer: AudioBuffer
  audio: CutterAudio
}): Promise<AudioBuffer> {
  const context = new OfflineAudioContext(numberOfChannels, length, audioBuffer.sampleRate)

  chunks.forEach((chunk) => {
    if (isAudioBufferChunk(chunk)) {
      const source = context.createBufferSource()
      source.buffer = audioBuffer
      source.onended = () => source.disconnect()
      source.connect(context.destination)
      source.start(
        chunk.start / audioBuffer.sampleRate,
        chunk.offset / audioBuffer.sampleRate,
        chunk.length / audioBuffer.sampleRate,
      )
    }
  })

  return context.startRendering()
}
